/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Tuesday, April 26th 2022, 4:58:49 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { useNavigate } from "react-router-dom";
import { URLS } from "core/routes";
import { OSActionButton, EmptyStateActionWrapper, Image } from "ui-widgets";

export const EmptyWorkerTeamsCTA = () => {
  const navigate = useNavigate();

  return (
    <EmptyStateActionWrapper
      title="Worker is not part of any team"
      description="Teams allow your organization to assign roles in your service delivery process to different staff members."
      illustrationGraphic={<Image className="image-style-A" src="/img/teamwork.png" alt="Onestop Admin" />}
    >
      <OSActionButton variant="contained" size="large" onClick={() => navigate(URLS.allTeams)}>
        Go to Teams
      </OSActionButton>
    </EmptyStateActionWrapper>
  );
};
